module.exports = __webpack_public_path__ + "static/img/bg-fail-keduo.06ec0681.png";